import {
    DESTROY_DETAILS_DRAWER,
    UPDATE_TASK_LIST,
} from "../actions/availableActions";
import {TaskState} from "../../interfaces/store/reducers/taskState";
import {UpdateTaskListAction} from "../../interfaces/store/actions/task";
import {DestroyDetailsDrawerAction} from "../../interfaces/store/actions/job";

const initialState: TaskState = {
    list: [],
    cursor: null,
};

type AvailableActions =
    UpdateTaskListAction
    | DestroyDetailsDrawerAction;

const taskReducer = (state:TaskState = initialState, action: AvailableActions): TaskState => {
    switch (action.type) {
        case UPDATE_TASK_LIST:
            return {
                ...state,
                ...action.payload,
            };
        case DESTROY_DETAILS_DRAWER:
            return {
                ...initialState,
            };
        default:
            return state;
    }
};

export default taskReducer;
